<template>
  <div>

    <!-- Action bar -->
    <div class="d-flex align-center mb-4">
      <v-spacer />
      <v-btn
        elevation="0"
        :loading="loading"
        @click="loadPreview"
        class="mr-2"
      >
        <v-icon left>mdi-eye-outline</v-icon>
        <span class="text-none">Prévisualiser</span>
      </v-btn>
      <v-btn
        color="primary"
        elevation="0"
        :loading="running"
        :disabled="!hasPendingChanges || running"
        @click="sync"
      >
        <v-icon left>mdi-sync</v-icon>
        <span class="text-none">Synchroniser</span>
      </v-btn>
    </div>

    <!-- Preview cards -->
    <div v-if="preview">
      <sync-mapping-card
        v-for="mapping in preview"
        :key="mapping.mapping_id"
        :mapping="mapping"
        :running="running"
        :previewing="previewingMappingId === mapping.mapping_id"
        :syncing="syncingMappingId === mapping.mapping_id"
        @preview="loadPreviewForMapping"
        @sync="syncMapping"
      />
    </div>

    <!-- Progress modal -->
    <v-dialog v-model="progressDialog" max-width="560" scrollable>
      <v-card>
        <v-card-title class="subtitle-1 font-weight-medium">
          <v-icon class="mr-2">mdi-text-box-outline</v-icon>
          Progression
          <v-spacer />
          <v-btn icon small @click="progressDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 400px; overflow-y: auto;">
          <div
            v-for="(event, i) in log"
            :key="i"
            class="d-flex align-center py-1"
          >
            <v-icon small class="mr-2" :color="logColor(event.type)">
              {{ logIcon(event.type) }}
            </v-icon>
            <span class="caption">{{ logLabel(event) }}</span>
          </div>

          <v-alert
            v-if="!running && syncDone"
            :type="hasLogErrors ? 'warning' : 'success'"
            dense outlined class="mt-3 mb-0"
          >
            {{ hasLogErrors ? 'Synchronisation terminée avec des erreurs.' : 'Synchronisation terminée avec succès.' }}
          </v-alert>
        </v-card-text>
        <v-card-actions v-if="!running && syncDone">
          <v-spacer />
          <v-btn text @click="progressDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import SyncMappingCard from '@/components/sync/SyncMappingCard.vue'

export default {
  name: 'SyncPanel',
  components: { SyncMappingCard },

  data() {
    return {
      syncingMappingId: null,
      previewingMappingId: null,
      progressDialog: false,
    }
  },

  computed: {
    preview()          { return this.$store.state.sync.preview },
    loading()          { return this.$store.state.sync.loading },
    running()          { return this.$store.state.sync.running },
    log()              { return this.$store.state.sync.log },
    hasPendingChanges(){ return this.$store.getters['sync/hasPendingChanges'] },
    syncDone()         { return this.log.some(e => e.type === 'all_done') },
    hasLogErrors()     { return this.log.some(e => e.type.endsWith('_error') || e.type === 'error') },
  },

  methods: {
    loadPreview() { this.$store.dispatch('sync/fetchPreview') },
    sync()        { this.progressDialog = true; this.$store.dispatch('sync/runSync') },

    async loadPreviewForMapping(id) {
      this.previewingMappingId = id
      await this.$store.dispatch('sync/fetchPreview')
      this.previewingMappingId = null
    },

    async syncMapping(id) {
      this.syncingMappingId = id
      this.progressDialog = true
      await this.$store.dispatch('sync/runSync', [id])
      this.syncingMappingId = null
    },

    logIcon(type) {
      const icons = {
        mapping_start: 'mdi-folder-outline',
        upload_start:  'mdi-upload',
        upload_done:   'mdi-check',
        upload_error:  'mdi-alert-circle-outline',
        remove_start:  'mdi-delete-outline',
        remove_done:   'mdi-check',
        remove_error:  'mdi-alert-circle-outline',
        mapping_done:  'mdi-check-circle-outline',
        all_done:      'mdi-check-all',
        error:         'mdi-alert-circle-outline',
      }
      return icons[type] || 'mdi-circle-small'
    },
    logColor(type) {
      if (type.endsWith('_error') || type === 'error') return 'error'
      if (type.endsWith('_done') || type === 'all_done') return 'success'
      if (type === 'remove_start') return 'warning'
      return 'primary'
    },
    logLabel(event) {
      const { type, mapping, file, message } = event
      if (type === 'mapping_start') return `${mapping} — démarrage`
      if (type === 'mapping_done')  return `${mapping} — synchronisé`
      if (type === 'upload_start')  return `${mapping} / ${file} — envoi…`
      if (type === 'upload_done')   return `${mapping} / ${file} — ajouté`
      if (type === 'upload_error')  return `${mapping} / ${file} — erreur : ${message}`
      if (type === 'remove_start')  return `${mapping} / ${file} — suppression…`
      if (type === 'remove_done')   return `${mapping} / ${file} — supprimé`
      if (type === 'remove_error')  return `${mapping} / ${file} — erreur : ${message}`
      if (type === 'all_done')      return 'Synchronisation terminée'
      if (type === 'error')         return `${mapping} — erreur : ${message}`
      return type
    },
  },
}
</script>
